import { PAYMENT_INTENT_INFO_COOKIE_NAME } from "app/constants";
import Cookies from "js-cookie";

export type PaymentIntentInfoCookie = {
  paymentIntentId: string;
  pointTypeId: number;
  articleIds?: string[];
  articleIndexIds?: number[];
  seriesId?: string;
  seriesIndexId?: number;
  amount?: number;
  ticketCount?: number;
};

/**
 * 3DSリダイレクト前に保持していたコインチャージ・レンタルに必要な情報をcookieから復元（client component用）
 * @returns
 */
export function getPaymentIntentInfoFromCookieOnClient(): PaymentIntentInfoCookie | null {
  const data = Cookies.get(PAYMENT_INTENT_INFO_COOKIE_NAME);
  if (data) {
    const json = JSON.parse(data || "") as PaymentIntentInfoCookie;
    return json;
  }
  return null;
}

/**
 * 3Dリダイレクト前に保存したCookieを削除する
 */
export function deletePaymentIntentInfoFromCookieOnClient(): void {
  const data = Cookies.get(PAYMENT_INTENT_INFO_COOKIE_NAME);
  if (data) {
    Cookies.remove(PAYMENT_INTENT_INFO_COOKIE_NAME);
  }
}
